import React from 'react';
import styles from './badge.module.scss';
import cx from "classnames";

const newBadge = '/images/newBadge.png'
interface BadgeProps {
    className?: string;
}

const Badge: React.FC<BadgeProps>  = ({className}) => {
  return (
    <>
      <img
        className={cx(styles.badgeImage, className)}
        src={newBadge}
        alt="Badge Image"
      />
    </>
  );
};

export default Badge;